module.exports = __webpack_public_path__ + "media/images/flavours/icon-vegetal_dark-e9aac13b379fc83e61c2efd6532aedd5.png";